import { SalesOrderStatus } from '../../constants/sales-order-status.js';
/** Inventory is committed or on its way but the order isn't delivered yet -- pipeline exposure, not a receivable. */
export const IN_FLIGHT_SALES_ORDER_STATUS_IDS = new Set([
    SalesOrderStatus.ACCEPTED,
    SalesOrderStatus.DELIVERY_SCHEDULING,
    SalesOrderStatus.READY_TO_DELIVER,
    SalesOrderStatus.SHIPPED,
]);
//# sourceMappingURL=in-flight-sales-order-status-ids.js.map